module.exports = __webpack_public_path__ + "img/right.83be4ff0.png";